import { Skeleton } from '@/components/ui/skeleton';

export default function MessageSkeleton({ count = 3 }) {
  return (
    <div className="space-y-6 px-4 py-6">
      {Array.from({ length: count }).map((_, i) => {
        const isUser = i % 2 === 0;
        return (
          <div key={i} className={`flex gap-3 ${isUser ? 'flex-row-reverse' : 'flex-row'}`}>
            <Skeleton className="size-8 rounded-full shrink-0" />
            <div className={`space-y-2 ${isUser ? 'items-end' : 'items-start'} flex flex-col`}>
              <Skeleton className="h-4 w-48" />
              {!isUser && <Skeleton className="h-4 w-64" />}
              {!isUser && <Skeleton className="h-4 w-36" />}
            </div>
          </div>
        );
      })}
    </div>
  );
}
